import { observable } from 'mobx';

class BluetoothStore {
  // 蓝牙打开状态 loading:正在打开 success:成功 error:蓝牙打开失败
  @observable status = 'loading';

  // 蓝牙打开失败或者成功的消息
  @observable message = '';
}

BluetoothStore.Connect = class {
  // 连接状态
  @observable status = 'loading';

  @observable authStatus = 'loading';

  // 连接成功后的数据
  @observable btData = {
    id: '',
    name: ''
  };
};

export default BluetoothStore;

export const bluetoothStore = new BluetoothStore();
export const bluetoothConnectStore = new BluetoothStore.Connect();
